<style lang="less">
  @import './assets/font/font.css';
  #app {
    font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html,
  body,
  .app-x {
    width: 100%;
    height: 100%;
  }

  ul,
  li,
  ol {
    list-style: none;
  }

  .app-x {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .app-navbar-x,
  .app-tabbar-x {
    width: 100%;
    flex-shrink: 0;
  }

  .app-content-x {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .page-content {
    height: 100%;
    overflow: auto;
  }
</style>
<style lang="less" scoped>
  .toBrowser-img {
    display: block;
    width: 90%;
    // margin: 0 auto;
    margin: 0 2% 0 8%;
    // margin: 0 0 0 15%;
  }

  .mask-close-icon {
    // @len: 20px;
    // text-align: center;
    // margin-top: @len;
    // position: relative;

    // &::before {
    //   content: '';
    //   position: absolute;
    //   bottom: 100%;
    //   left: 50%;
    //   transform: translate(-50%, 2px);
    //   width: 3px;
    //   height: @len;
    //   background-color: #fff;
    // }
  }
  .close-text {
    padding: 9px 38px;
    // display: block;
    display: inline;

    border-radius: 90px;
    border: 1px solid #ffffffb3;

    color: #ffffff;
    text-align: center;
    font-size: 14px;
    font-weight: 400;

    position: absolute;

    left: 50%;
    transform: translate(-50%, 30px);
  }
</style>

<template>
  <van-config-provider class="app-x" :theme-vars="vantCssVars">
    <div v-show="navbarInfo.show" ref="appNavbarRef" class="app-navbar-x">
      <local-navbar />
    </div>
    <div class="app-content-x">
      <router-view v-slot="{ Component }">
        <keep-alive :include="['ReportInspection']">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>
    <div v-show="tabbarInfo.show" ref="appTabbarRef" class="app-tabbar-x">
      <Tabbar v-model:show="tabbarInfo.show" />
    </div>

    <!-- <van-overlay :show="isWechat" :z-index="999">
      <img class="toBrowser-img" :src="`${VITE_IMG_BASE_URL}/v1.0.5/QToBrowserTwo.png`" alt="" />
      <div class="mask-close-icon" v-if="canCloseMask">
        <van-icon color="#fff" size="36px" name="close" @click="toggleWechatMask(false)" />
      </div>
    </van-overlay> -->
    <!-- isWechat -->
    <!-- <van-overlay :show="isWechat" :z-index="999">
      <img class="toBrowser-img" :src="`${VITE_IMG_BASE_URL}/v1.0.5/QToBrowserTwo.png`" alt="" />
      <div class="close-text" v-if="canCloseMask" @click="toggleWechatMask(false)"> 我知道了 </div>
    </van-overlay> -->

    <van-overlay :show="isWechat" :z-index="999">
      <img class="toBrowser-img" :src="`${VITE_IMG_BASE_URL}/v1.0.5/QToBrowserThree.png`" alt="" />
      <!-- <div class="close-text" v-if="canCloseMask" @click="toggleWechatMask(false)"> 我知道了 </div> -->
    </van-overlay>
    <login-pop />
  </van-config-provider>
</template>

<script setup lang="ts">
  import copyPaste from '@/utils/lib/copy-paste';
  import LoginPop from '@/components/login/index.vue';
  import Tabbar from './components/tabbar/index.vue';
  import { register } from 'swiper/element/bundle';
  import { checkIsWechat, checkIsQQApp, checkBrowserEnv } from './utils/utils';
  import { useAppInfo } from './store';
  import { useElementSize } from '@vueuse/core';
  import { ConfigProviderThemeVars } from 'vant';
  import LocalNavbar from './components/localNavbar/index.vue';

  const { VITE_IMG_BASE_URL } = import.meta.env;
  const route = useRoute();
  const router = useRouter();
  const appInfoStore = useAppInfo();
  // 注册 swiper 组件
  register();

  // 是否是微信端
  const isWechat = ref(false);
  const canCloseMask = ref(false);
  const toggleWechatMask = (val: boolean) => (isWechat.value = val);
  provide('isWechat', isWechat);
  provide('toggleWechatMask', toggleWechatMask);

  // 图片前缀
  provide(
    'imgBaseUrl',
    VITE_IMG_BASE_URL || 'https://cloud-assets-fronts-dev.fengmtech.com/miniprogram'
  );

  const tabbarInfo = reactive({ show: false });
  const navbarInfo = reactive({ show: true });
  watch(
    route,
    (newVal) => {
      console.log({ route }, 'App');

      const disabledNavBar = newVal.meta.disabledNavBar;
      navbarInfo.show =
        typeof disabledNavBar === 'function' ? disabledNavBar(newVal) : !disabledNavBar;

      // 检测微信浏览器
      if (newVal.meta) {
        newVal.meta.checkBrowser &&
          (isWechat.value = checkBrowserEnv('wechat') || checkBrowserEnv('qq'));
        canCloseMask.value = !!newVal.meta.canCloseMask;
      }
      // (isWechat.value = checkIsWechat() || checkIsQQApp());
    },
    { immediate: true }
  );

  // 设置一下 App 的全局信息
  const appTabbarRef = ref<HTMLDivElement>();
  const { height: tabbarHei } = useElementSize(appTabbarRef);
  const appNavbarRef = ref<HTMLDivElement>();
  const { height: navbarHei } = useElementSize(appNavbarRef);
  watchEffect(() => {
    appInfoStore.setTabbarInfo({ height: Math.ceil(tabbarHei.value) });
    appInfoStore.setNavbarInfo({ height: Math.ceil(navbarHei.value) });
  });

  onMounted(async () => await router.isReady());
  onBeforeUnmount(() => copyPaste.enable());

  // 配置主题
  const vantCssVars: ConfigProviderThemeVars = {
    blue: '#186ef9',
  };
</script>
